"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: none;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 100%;\n  height: 92px;\n  background-color: ", ";\n  font-size: 14px;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var UnavailablePlanButton = _styledComponents.default.div.withConfig({
  displayName: "UnavailablePlanButton",
  componentId: "ruxqzy-0"
})(_templateObject(), _colors.GYPSUM, _responsiveBreakpoints.default.phone(_templateObject2()));

var _default = UnavailablePlanButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/UnavailablePlanButton.js
// module id = 784
// module chunks = 5 6